<div class="slideout-content">
    <!-- Modal to add new user starts-->
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0" [formGroup]="currencyForm">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-currency')">
                    ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">Para Birimi Ekle</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="row">
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="currencyName">Para Birimi</label>
                                <input type="text" formControlName="currencyName" class="form-control"
                                    placeholder="Para Birimi Giriniz." />
                                <div *ngIf="currencyName.invalid && (currencyName.dirty || currencyName.touched)">
                                    <small class="text-danger" *ngIf="currencyName.errors.required">Para Birimi
                                        zorunludur.</small>
                                    <small class="text-danger" *ngIf="currencyName.errors.maxlength">Para Birimi en
                                        fazla 25 karakter olabilir.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" [disabled]="currencyForm.invalid" class="btn btn-primary col-10 mb-1 ml-1" (click)="onSubmit()" rippleEffect>Ekle</button>
                    <button type="reset" class="btn btn-outline-secondary col-10 mb-1 ml-1" (click)="toggleSidebar('create-currency')"
                        rippleEffect>
                        İptal
                    </button>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>
